/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BrandHealthFromJSON, BrandHealthToJSON } from './BrandHealth';
/**
 * Check if a given object implements the BrandsResponse interface.
 */
export function instanceOfBrandsResponse(value) {
    if (!('brands' in value) || value['brands'] === undefined)
        return false;
    if (!('fetchedAt' in value) || value['fetchedAt'] === undefined)
        return false;
    return true;
}
export function BrandsResponseFromJSON(json) {
    return BrandsResponseFromJSONTyped(json, false);
}
export function BrandsResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'brands': (json['brands'].map(BrandHealthFromJSON)),
        'fetchedAt': json['fetched_at'],
    };
}
export function BrandsResponseToJSON(json) {
    return BrandsResponseToJSONTyped(json, false);
}
export function BrandsResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'brands': (value['brands'].map(BrandHealthToJSON)),
        'fetched_at': value['fetchedAt'],
    };
}
